// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2kPtU","options":"AnswerScale_options__1LapA","selected":"AnswerScale_selected__36RP0"};